import React, { Component, Fragment } from 'react';
import { Form, FormFeedback, FormGroup, Input, Label } from 'reactstrap';
import withValidator from '../../../models/form/withValidator';
import LoadingButton from '../../../../shared/ui/LoadingButton';

const validatorConfig = {
  cssClasses: {
    fieldInvalid: 'is-invalid',
    fieldValid: 'is-valid',
  },
  fields: {
    label: {
      rules: [
        {
          feedback: 'Label is required',
          test(value) {
            return !!value;
          },
        },
      ],
    },
    address: {
      rules: [
        {
          feedback: 'address is required',
          test(value) {
            return !!value;
          },
        },
      ],
    },
    city: {
      rules: [
        {
          feedback: 'city is required',
          test(value) {
            return !!value;
          },
        },
      ],
    },
    state: {
      rules: [
        {
          feedback: 'state is required',
          test(value) {
            return !!value;
          },
        },
      ],
    },
    zipCode: {
      rules: [
        {
          feedback: 'zipCode is required',
          test(value) {
            return !!value;
          },
        },
      ],
    },
  },
};

class AddressForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cssValidationClasses: {
        label: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
      },
      errorFeedback: {},
      isDefault: !this.props.initialValues
        ? false
        : this.props.initialValues.isDefault,
      isFormDisabled: true,
      label: !this.props.initialValues ? '' : this.props.initialValues.label,
      address: !this.props.initialValues
        ? ''
        : this.props.initialValues.address,
      city: !this.props.initialValues ? '' : this.props.initialValues.city,
      state: !this.props.initialValues ? '' : this.props.initialValues.state,
      zipCode: !this.props.initialValues
        ? ''
        : this.props.initialValues.zipCode,
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    if (this.props.initialValues) {
      this.props.initialize({
        label: this.state.label,
        address: this.state.address,
        city: this.state.city,
        state: this.state.state,
        zipCode: this.state.zipCode,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      cssValidationClasses: nextProps.cssValidationClasses,
      errorFeedback: nextProps.errorFeedback,
      isFormDisabled: this.getIsFormInvalid(
        nextProps.hasErrors,
        nextProps.hasUntouched,
      ),
    });
    if (
      nextProps.initialValues &&
      !Object.is(this.props.initialValues, nextProps.initialValues)
    ) {
      this.setState({
        isDefault: nextProps.initialValues.isDefault,
        label: nextProps.initialValues.label,
        address: nextProps.initialValues.address,
        city: nextProps.initialValues.city,
        state: nextProps.initialValues.state,
        zipCode: nextProps.initialValues.zipCode,
      });
    }
  }

  // ----------------------
  // Methods
  // ----------------------

  getIsFormInvalid(hasErrors, hasUntouched) {
    return hasErrors || hasUntouched;
  }

  handleBlur(event) {
    const { name, value } = event.target;
    this.props.touch(name);
    this.props.validateField(name, value);
  }

  handleInput(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () =>
      this.props.validateField(name, value, true));
  }

  handleSubmit(event) {
    event.preventDefault();
    const properties = {
      isDefault: this.state.isDefault,
      label: this.state.label,
      address: this.state.address,
      city: this.state.city,
      state: this.state.state,
      zipCode: this.state.zipCode,
    };
    this.props.onSave(properties);
  }

  render() {
    return (
      <Fragment>
        <Form noValidate onSubmit={event => this.handleSubmit(event)}>
          <FormGroup>
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <Label for="label">
              Label <i className="fa fa-asterisk" />
            </Label>
            <Input
              autoComplete="off"
              className={this.state.cssValidationClasses.label}
              id="label"
              name="label"
              onBlur={event => this.handleBlur(event)}
              onChange={event => this.handleInput(event)}
              placeholder="Label"
              type="text"
              value={this.state.label}
            />
            <FormFeedback>{this.state.errorFeedback.label}</FormFeedback>
          </FormGroup>
          <FormGroup>
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <Label for="address">
              Address <i className="fa fa-asterisk" />
            </Label>
            <Input
              autoComplete="off"
              className={this.state.cssValidationClasses.address}
              id="address"
              name="address"
              onBlur={event => this.handleBlur(event)}
              onChange={event => this.handleInput(event)}
              placeholder="Address"
              type="text"
              value={this.state.address}
            />
            <FormFeedback>{this.state.errorFeedback.address}</FormFeedback>
          </FormGroup>
          <FormGroup>
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <Label for="city">
              City <i className="fa fa-asterisk" />
            </Label>
            <Input
              autoComplete="off"
              className={this.state.cssValidationClasses.city}
              id="city"
              name="city"
              onBlur={event => this.handleBlur(event)}
              onChange={event => this.handleInput(event)}
              placeholder="City"
              type="text"
              value={this.state.city}
            />
            <FormFeedback>{this.state.errorFeedback.city}</FormFeedback>
          </FormGroup>
          <FormGroup>
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <Label for="state">
              State <i className="fa fa-asterisk" />
            </Label>
            <Input
              className={this.state.cssValidationClasses.state}
              id="state"
              name="state"
              onBlur={event => this.handleBlur(event)}
              onChange={event => this.handleInput(event)}
              type="select"
              value={this.state.state}
            >
              <option defaultValue value="">
                Select State
              </option>
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="DC">District Of Columbia</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
            </Input>
            <FormFeedback>{this.state.errorFeedback.state}</FormFeedback>
          </FormGroup>
          <FormGroup>
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <Label for="zipCode">
              ZipCode <i className="fa fa-asterisk" />
            </Label>
            <Input
              autoComplete="off"
              className={this.state.cssValidationClasses.zipCode}
              id="zipCode"
              name="zipCode"
              onBlur={event => this.handleBlur(event)}
              onChange={event => this.handleInput(event)}
              placeholder="Zip Code"
              type="text"
              value={this.state.zipCode}
            />
            <FormFeedback>{this.state.errorFeedback.zipCode}</FormFeedback>
          </FormGroup>
          <div style={{ textAlign: 'right' }}>
            <LoadingButton
              primary
              text="Submit"
              isLoading={this.props.isLoading}
              disabled={this.state.isFormDisabled}
            />
          </div>
        </Form>
      </Fragment>
    );
  }
}

export default withValidator(AddressForm, validatorConfig);
